import React from 'react'
import {
  Grid,  Typography, Card, CardHeader, CardContent, Divider } from '@mui/material'

const PerSqftTargetsSection = ({ PerSqftLotTargetFields = []  }) => (
  <Grid
    container
    direction="row"
    spacing={1}
    style={{ marginBottom: 10 }}
  >
    <Grid size={12}>
      <Card>
        <CardHeader
          title={<Typography variant="h6">Per sqft</Typography>}
        />
        <Divider />
        <CardContent>
          {(PerSqftLotTargetFields || []).map((field, idx) => (
            <Grid
              container
              direction="row"
              key={idx}
              sx={{
                justifyContent: "space-between"
              }}
            >
              <Grid data-hf-grid="keep">
                <Typography>{field.label}:</Typography>
              </Grid>
              <Grid data-hf-grid="keep">
                <Typography>
                  {field.decimal
                    ? field.value.toLocaleString(undefined, {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 2 })
                    : field.value.toLocaleString(undefined, {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0})}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </CardContent>
      </Card>
    </Grid>
  </Grid>
)

export default PerSqftTargetsSection
